import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ExercisesQuestionsCard } from '@/pages/exercises/exercises-questions/exercises-questions-card';
import { useClient } from 'jsonapi-react';
import { Loader } from '@/components/custom/loader';
import { QuestionList, QuestionSidebarWrapper } from '@/components/custom/question';
import { DashboardContent } from '@/layouts/dashboard';

export default function CommentQuestion(props) {
  const { uri } = props;

  const { questionId } = useParams();
  const client = useClient();
  const [question, setQuestion] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getQuestion = async id => {
      const { data } = await client.fetch(`/questions/${id}?with_comments=true`);
      setQuestion(data);
    };
    getQuestion(questionId);
    setLoading(false);
  }, [questionId, loading]);

  if (loading || !question) {
    return <Loader />;
  }

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: '/avaliacoes/banco-de-questoes',
        name: 'Banco de Questões',
        isActive: false
      },
      {
        route: uri,
        name: `Q${questionId} ${question?.code}`,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <DashboardContent style={{ marginLeft: '0', width: '100%', paddingTop: '0' }}>
        <QuestionList>
          <ExercisesQuestionsCard
            groupedQuestion={[question]}
            taxonomyIds={question?.taxonomies.map(item => item?.id)}
          />
        </QuestionList>

        <QuestionSidebarWrapper />
      </DashboardContent>
    </DashboardContent>
  );
}
